import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  CREATE_NEWS_GENERATION_RECORD,
  UPDATE_NEWS_GENERATION_RECORD,
  DELETE_NEWS_GENERATION_RECORD,
  GET_NEWS_GENERATION_RECORD,
  LIST_NEWS_GENERATION_RECORDS,
  createNewsGenerationRecordSuccess,
  createNewsGenerationRecordFailure,
  updateNewsGenerationRecordSuccess,
  updateNewsGenerationRecordFailure,
  deleteNewsGenerationRecordSuccess,
  deleteNewsGenerationRecordFailure,
  getNewsGenerationRecordSuccess,
  getNewsGenerationRecordFailure,
  listNewsGenerationRecordsSuccess,
  listNewsGenerationRecordsFailure,
} from "../actions/newsGenerationActions";
import {
  createNewsGenerationRecordApi,
  updateNewsGenerationRecordApi,
  deleteNewsGenerationRecordApi,
  getNewsGenerationRecordApi,
  listNewsGenerationRecordsApi,
} from "../apis/newsGenerationApi";

// Saga to handle creating a news generation record
function* initiateCreateNewsGenerationRecord(action) {
  try {
    console.log(
      `PMM - SF - newsGenerationSaga.js - initiateCreateNewsGenerationRecord - action is: ${JSON.stringify(
        action
      )}`
    );

    const newsGenerationInput = action.payload;
    console.log(
      `PMM - SF - newsGenerationSaga.js - initiateCreateNewsGenerationRecord - newsGenerationInput is: ${JSON.stringify(
        newsGenerationInput
      )}`
    );

    const response = yield call(
      createNewsGenerationRecordApi,
      newsGenerationInput
    );
    console.log(
      `PMM - SF - newsGenerationSaga - response is: ${JSON.stringify(response)}`
    );
    // Dispatch the success action with the returned response
    yield put(createNewsGenerationRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(createNewsGenerationRecordFailure(error.message));
  }
}

// Saga to handle updating a news generation record
function* initiateUpdateNewsGenerationRecord(action) {
  try {
    const response = yield call(updateNewsGenerationRecordApi, action.payload);
    // Dispatch the success action with the updated response
    yield put(updateNewsGenerationRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(updateNewsGenerationRecordFailure(error.message));
  }
}

// Saga to handle deleting a news generation record
function* initiateDeleteNewsGenerationRecord(action) {
  try {
    const { newsId, tenantId } = action.payload;
    const response = yield call(
      deleteNewsGenerationRecordApi,
      newsId,
      tenantId
    );
    // Dispatch the success action with a success message
    yield put(deleteNewsGenerationRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(deleteNewsGenerationRecordFailure(error.message));
  }
}

// Saga to handle retrieving a single news generation record
function* initiateGetNewsGenerationRecord(action) {
  try {
    const { newsId, tenantId } = action.payload;
    const response = yield call(getNewsGenerationRecordApi, newsId, tenantId);
    // Dispatch the success action with the retrieved news generation record
    yield put(getNewsGenerationRecordSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(getNewsGenerationRecordFailure(error.message));
  }
}

// Saga to handle listing news generation records
function* initiateListNewsGenerationRecords(action) {
  try {
    const { tenantId, status, limit } = action.payload;
    const response = yield call(
      listNewsGenerationRecordsApi,
      tenantId,
      status,
      limit
    );
    // Dispatch the success action with the news generation records connection
    yield put(listNewsGenerationRecordsSuccess(response));
  } catch (error) {
    // Dispatch the failure action with the error message
    yield put(listNewsGenerationRecordsFailure(error.message));
  }
}

// Watcher saga for create news generation record
function* watchInitiateCreateNewsGenerationRecord() {
  yield takeLatest(
    CREATE_NEWS_GENERATION_RECORD,
    initiateCreateNewsGenerationRecord
  );
}

// Watcher saga for update news generation record
function* watchInitiateUpdateNewsGenerationRecord() {
  yield takeLatest(
    UPDATE_NEWS_GENERATION_RECORD,
    initiateUpdateNewsGenerationRecord
  );
}

// Watcher saga for delete news generation record
function* watchInitiateDeleteNewsGenerationRecord() {
  yield takeLatest(
    DELETE_NEWS_GENERATION_RECORD,
    initiateDeleteNewsGenerationRecord
  );
}

// Watcher saga for get news generation record
function* watchInitiateGetNewsGenerationRecord() {
  yield takeLatest(GET_NEWS_GENERATION_RECORD, initiateGetNewsGenerationRecord);
}

// Watcher saga for list news generation records
function* watchInitiateListNewsGenerationRecords() {
  yield takeLatest(
    LIST_NEWS_GENERATION_RECORDS,
    initiateListNewsGenerationRecords
  );
}

// Root saga that bundles all news generation watchers
export default function* newsGenerationSaga() {
  yield all([
    watchInitiateCreateNewsGenerationRecord(),
    watchInitiateUpdateNewsGenerationRecord(),
    watchInitiateDeleteNewsGenerationRecord(),
    watchInitiateGetNewsGenerationRecord(),
    watchInitiateListNewsGenerationRecords(),
  ]);
}
